<template>
  <v-dialog :scrim="true" v-model="model" persistent max-width="330">
    <v-card>
      <v-card-title>{{ dialogTitle }}</v-card-title>

      <v-card-text class="pre-line">
        {{ dialogText }}
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn variant="text" color="primary" @click="onConfirm"> {{ confirmButtonText }} </v-btn>

        <v-btn variant="text" color="error" @click="onCancel"> {{ cancelButtonText }} </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  modelValue: boolean;
  dialogTitle: string;
  dialogText: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
  (e: "confirm"): void;
  (e: "cancel"): void;
}>();

const model = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const confirmButtonText = computed(() => props.confirmButtonText || "Confirm");
const cancelButtonText = computed(() => props.cancelButtonText || "Cancel");

function onConfirm() {
  emit("confirm");
  model.value = false;
}

function onCancel() {
  emit("cancel");
  model.value = false;
}
</script>

<style scoped>
.pre-line {
  white-space: pre-line;
}
</style>
